module.exports = __webpack_public_path__ + "static/media/logo.986cbfa8.png";